import { render, staticRenderFns } from "./WorkRequestEdit.vue?vue&type=template&id=321b1896&"
import script from "./WorkRequestEdit.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports